import { ComponentStyleConfig } from '@chakra-ui/react';

const _disabled = {
  opacity: '0.6',
  bg: 'neutral.200',
  color: 'neutral.400',
};

export const button: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: 'button',
  },
  sizes: {
    xs: {
      h: 'xxsmall',
      py: 'pico',
      px: 'micro',
    },
    sm: {
      h: 'small',
      py: 'nano',
      px: 'centi',
      fontWeight: '400',
    },
    md: {
      h: 'large',
      px: 'deci',
      py: 'milli',
    },
    lg: {
      h: 'xlarge',
      px: 'kilo',
      py: 'centi',
    },
    xl: {
      h: 'xxlarge',
      minW: 'xxlarge',
      fontSize: 'lg',
      fontWeight: '600',
      py: 'deci',
      px: 'xxsmall',
    },
  },
  variants: {
    primary: {
      bg: 'brand.500',
      color: 'white',
      fontWeight: 600,
      borderRadius: 'button',
      _hover: {
        bg: 'brand.600',
        color: 'white',
        _disabled,
      },
      _active: {
        bg: 'brand.600',
        _disabled,
      },
      _disabled,
    },
    gradient: {
      backgroundImage: 'linear-gradient(to bottom, brand.500, brand.400)',
      color: 'white',
    },
    buttonLink: {
      bg: 'none',
      color: 'neutral.300',
      textDecor: 'underline',

      _hover: {
        textDecor: 'underline',
      },
    },
    outlined: {
      bg: 'white',
      border: '1px solid',
      borderColor: 'transparent.500',
      color: 'brand.500',
    },
  },
  defaultProps: {
    size: 'sm',
    variant: 'primary',
  },
};
